function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M10.29 4.86L1.82 19a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 4.86a2 2 0 00-3.42 0z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 10v4",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 18,
  r: 1,
  fill: "currentColor"
});

function SvgIconError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgIconError;